import { motion } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

export const MaskLines = ({ lines, className = "", lineClassName = "", delay = 0.2 }) => (
  <span className={`block ${className}`}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.06em]">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "105%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1.05, ease: EASE, delay: delay + i * 0.12 }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const Reveal = ({ children, delay = 0, className = "", y = 36 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay }}
  >
    {children}
  </motion.div>
);

export const Marquee = ({ items, className = "" }) => {
  const row = [...items, ...items];
  return (
    <div className={`overflow-hidden whitespace-nowrap ${className}`} data-testid="editorial-marquee">
      <div className="inline-flex animate-marquee">
        {[0, 1].map((k) => (
          <div key={k} className="inline-flex items-center" aria-hidden={k === 1}>
            {row.map((t, i) => (
              <span key={i} className="inline-flex items-center font-display uppercase text-5xl sm:text-7xl px-6">
                {t}
                <span className="ml-12 text-[#E10600]">✕</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
